import React from 'react';
import QualHeader from './header/QualHeader'
import QualLeftSideBar from './QualLeftSideBar'
import QualRightSideBar from './QualRightSideBar'
import QualContent from './QualContent'
import ColorConstants from 'constants/ColorConstants'
import TermsOfServiceModal from './TermsOfServiceModal'
import SubscriptionModal from './SubscriptionModal'
import { useLocation } from 'react-router-dom';
import CodeableContextProvider from 'codeable/CodeableContextProvider';
import CodeOperationsProvider from 'codeable/CodeOperationsProvider';
import {useOnboarding} from 'hooks/onboarding/useOnboarding';
import { useRightSideBar } from 'hooks/useRightSideBar';
import { useIsProjectOwner } from 'hooks/users/useIsProjectOwner';
import CableLayer from './CableLayer';
import { BillingModalProvider } from '../../contexts/BillingModalContext';
import { CollabModalProvider } from '../../contexts/CollabModalContext';
import { FilterStateProvider } from '../../contexts/FilterStateContext';
import { FileUploadProvider } from '../../contexts/FileUploadContext';
import useCoders from 'hooks/useCoders';

import {
  HEADER_HEIGHT,
  LEFT_WIDTH,
  RIGHT_WIDTH,
  CONTENT_MIN_WIDTH
} from 'constants/DimensionsConstants'

const allStyle = {
  margin:0,
  border:0,
  position:"relative",
  height:"100vh",
}

const leftStyle = {
    left:0,
    top:0,
    padding:0,
    margin:0,
    width:LEFT_WIDTH + "px",
    height:"100%",
    background:ColorConstants.DARK_GREY,
    position:"absolute",
    margin:"0px",
    boxSizing: "border-box",
}

const mainStyle = {
  marginLeft:LEFT_WIDTH + "px",
  marginRight:"0px",
  padding:"0px",
  height:"100%",
  display: "flex",
  flexDirection: "column",
  //background:"blue",
  minWidth:LEFT_WIDTH + RIGHT_WIDTH + CONTENT_MIN_WIDTH + "px",
  boxSizing: "border-box",
}

const withoutRightSideBar = {
  ...mainStyle,
  minWidth: LEFT_WIDTH + CONTENT_MIN_WIDTH + "px",
}

const headerStyle = {
  //background:"orange",
  flexShrink: 0,  // Don't shrink
  width:"100%",
  borderBottom: "1px solid lightGray",
  boxSizing: "border-box",
}

const bodyStyle = {
  width:"100%",
  flex: 1,  // Take remaining space
  position:"relative",
  boxSizing: "border-box",
  overflow: "hidden",  // Prevent overflow
}

const contentStyle = {
    //background:"yellow",
    marginRight:RIGHT_WIDTH + "px",
    height:"100%",
    minWidth: CONTENT_MIN_WIDTH + "px",
    boxSizing: "border-box",
}

const rightStyle = {
  //background:"green",
  width:RIGHT_WIDTH + "px",
  position:"absolute",
  right:0,
  top:0,
  height:"100%",
  borderLeft: "1px solid lightGray",
  boxSizing: "border-box",
  paddingTop:"0px",
  marginTop:"0px",
}

const wrapperStyle = {
  padding:"10px 10px 10px 30px"
}

const SNavigation = (props) => {
  const location = useLocation();
  const onboardingState = useOnboarding(props.projectID);
  const coders = useCoders(location.pathname);
  const codingUserId = coders.length > 0 ? coders[0] : undefined;




  // Removed useEffect for dimensions - no longer needed

  // No longer need to update styles dynamically
  // Styles are now set with CSS calc() and viewport units

  const isArchived = (props.project || {}).status === 'archived';

  const rightSideBar = useRightSideBar({
    rightSideBarProp: props.rightSideBar,
    onboardingState,
    requiresExcerpts: props.requiresExcerpts,
    requiresCodes: props.requiresCodes,
    projectID: props.projectID,
    isArchived
  });
  
  const role = (props.project || {}).role;
  const roleIsEdit = role === 'edit';
  const hasEditPermission = props.hasEditPermission;
  const isProjectOwner = useIsProjectOwner(props.project);

  return (
    <div style={allStyle}>
      { !!SOCKET_URL_PREFIX && <CableLayer projectID={props.projectID}/> }

      <SubscriptionModal/>
      <TermsOfServiceModal/>

      <div style={{...leftStyle, height: '100vh'}}>
        <QualLeftSideBar
          projectID={props.projectID}
          transcriptID={props.transcriptID}
          hasEditPermission={hasEditPermission}
        />
      </div>
      <FilterStateProvider projectID={props.projectID}>
        <div style={rightSideBar ? mainStyle : withoutRightSideBar}>
          <div style={headerStyle}>
            <div style={wrapperStyle}>
              <QualHeader
                hasEditPermission={hasEditPermission}
                roleIsEdit={roleIsEdit}
              />
            </div>
          </div>
          <CodeableContextProvider
            projectId={props.projectID}
            codeableId={props.transcriptID}
          >
            <CodeOperationsProvider
              projectId={props.projectID}
              codingUserId={codingUserId}
            >
              <div style={bodyStyle}>
                <div style={rightSideBar ? contentStyle : {
                  ...contentStyle,
                  marginRight: "0px"
                }}>
                  <QualContent
                    projectID={props.projectID}
                    transcriptID={props.transcriptID}
                    codeID={props.codeID}
                    style={{width:"100%"}}
                    hasEditPermission={hasEditPermission}
                    isArchived={isArchived}
                    isProjectOwner={isProjectOwner}
                    onboardingState={onboardingState}
                  />
                </div>
                {rightSideBar &&
                  <div style={rightStyle}>
                    <QualRightSideBar 
                      projectID={props.projectID}
                      transcriptID={props.transcriptID}
                        hasEditPermission={hasEditPermission}
                    />
                  </div>
                }
              </div>
            </CodeOperationsProvider>
          </CodeableContextProvider>
        </div>
      </FilterStateProvider>
    </div>
  );
}

// when these providers were rendered higher
// they did not get projectId updates. However when they are lower in the react tree they do
// it is unclear to me why that was.
const SNavigationWithProviders = (props) => {
  return (
    <BillingModalProvider>
      <CollabModalProvider>
        <FileUploadProvider>
          <SNavigation {...props} />
        </FileUploadProvider>
      </CollabModalProvider>
    </BillingModalProvider>
  );
};

export default SNavigationWithProviders;
